export const  amberEndpoints = {
    amberApi: {
        list: {
            api: '/interfaces',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/interfaces/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/interfaces',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/interfaces/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/interfaces/delete/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/interfaces/togglestatus/',
            method: 'POST',
            parameter: true
        }
    },
    client: {
        list: {
            api: '/clients',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/clients/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/clients',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/clients/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/clients/delete/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/clients/togglestatus/',
            method: 'POST',
            parameter: true
        }
    },
    system: {
        list: {
            api: '/systems',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/systems/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/systems',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/systems/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/systems/delete/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/systems/togglestatus/',
            method: 'POST',
            parameter: true
        },
        exportDataSystem: {
            api: '/systems/export/',
            method: 'GET',
            parameter: true
        },
        checkHealth: {
            api: '/systems/check/',
            method: 'POST',
            parameter: true
        },
        systemImport: {
            api: '/systems/import/',
            method: 'POST',
            parameter: true
        }
    },
    configuration: {
        list: {
            api: '/configurations',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/configurations/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/configurations',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/configurations/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/configurations/togglestatus/',
            method: 'POST',
            parameter: true
        }
    },
    connector: {
        list: {
            api: '/connectors',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/connectors/',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/connectors',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/connectors/',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/connectors/delete/',
            method: 'POST',
            parameter: true
        },
        checkConnectorHealth: {
            api: '/connectors/check/',
            method: 'POST',
            parameter: true
        },
        toggleStatus: {
            api: '/connectors/togglestatus/',
            method: 'POST',
            parameter: true
        }
    },
    communication: {
        listIncoming: {
            api: '/communications/incoming',
            method: 'GET',
            parameter: false
        },
        listOutgoing: {
            api: '/communications/outgoing',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/communications/',
            method: 'GET',
            parameter: true
        },
        errors: {
            api: '/communications/errors/export',
            method: 'GET',
            parameter: true
        }
    },
    other: {
        version: {
            api: '/version',
            method: 'GET',
            parameter: false
        }
    },
    users: {
        getPreference: {
            api: '/users/preferences/',
            method: 'GET',
            parameter: true
        },
        putPreference:{
            api: '/users/preferences/',
            method: 'POST',
            parameter: false
        },
        getGuidance: {
            api: '/users/guidance',
            method: 'GET',
            parameter: true
        },
        putGuidance: {
            api: '/users/guidance',
            method: 'POST',
            parameter: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/amber.endpoints.ts